"use client";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon, MinusIcon } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Radix Checkbox を Amethyst の見た目に合わせて描画します。
 * Radix は form 連携や accessibility のために内部 input / indicator へ inline style を出すため、
 * CSP 側で `style-src-attr 'unsafe-inline'` を明示的な互換例外として許可します。
 */
function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "group peer border-input dark:bg-input/30",
        "data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary",
        "aria-[checked=mixed]:bg-primary aria-[checked=mixed]:text-primary-foreground dark:aria-[checked=mixed]:bg-primary aria-[checked=mixed]:border-primary",
        "aria-[checked=true]:bg-primary aria-[checked=true]:text-primary-foreground dark:aria-[checked=true]:bg-primary aria-[checked=true]:border-primary",
        "focus-visible:border-ring focus-visible:ring-ring/50",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        "size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="group flex items-center justify-center text-current transition-none"
      >
        <CheckIcon className="size-3.5 hidden text-primary-foreground group-data-[state=checked]:block" />
        <MinusIcon className="size-3.5 hidden text-primary-foreground group-data-[state=indeterminate]:block" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
